import React from 'react'
import styled from '@emotion/styled'
import Image from 'next/image'
import OurBPImage from '../../../public/home/GS_home_our_bp.jpeg'
import { Header3, Header2, Text } from '../../styles/Components'
import Button from '../Button'
import { gsColors as c } from '../../styles/Variables'
import { mq } from '../../helpers'

const BeautyProsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  height: 907px;
  max-width: 1600px;

  ${mq('max', '768px')} {
    flex-direction: column;
    height: auto;
  }

  .image-placeholder {
    width: 50%;
    background-color: #4D4D4D;
    position: relative;

    img {
      object-fit: cover;
    }

    ${mq('max', '768px')} {
      height: 498px;
      width: 100%;
    }
  }

  .content {
    width: 50%;
    background-color: ${c.cobalt};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 16px;

    ${mq('max', '768px')} {
      width: 100%;
      align-items: flex-start;
    }

    .inner {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      margin: 16px;

      ${mq('max', '968px')} {
        h3 {
          font-size: 14px;
        }

        h2 {
         font-size: 25px;
        }

        p {
          font-size: 16.5px;
        }

        button {
          font-size: 14px;
        }
      }

      ${mq('max', '768px')} {
        margin: 0;
        width: 100%;
        align-items: flex-start;
        padding: 58px 0;

        button {
          margin-top: 8px;
        }

        h2 {
          margin-bottom: 24px;
        }
      }

      .bp-divider {
        width: 100%;
        border-top: 1px solid ${c.salmon};
        margin-bottom: 24px;

        ${mq('max', '768px')} {
          margin-bottom: 20px;
        }
      }
    }
  }
`

const aboutBeautyPros = [
  '7 years experience on average',
  'Fully licensed hair and nail artists ',
  'Hundreds of hours of experience required ',
  'Background checked',
]

const OurBeautyPros = () => {
  return (
    <BeautyProsWrapper>
      <div className="image-placeholder">
        <Image
          src={OurBPImage}
          alt="Our Beauty Professionals"
          style={{ objectFit: 'cover' }}
          fill
          priority
        />
      </div>
      <div className="content">
        <div className="inner">
          <Header3 color={c.salmon}>Get to know</Header3>
          <Header2 color={c.salmon} margin="0 0 60px 0">
            Our beauty pros
          </Header2>
          {aboutBeautyPros.map((v, i, a) => (
            <React.Fragment key={i}>
              <Text
                color={c.salmon}
                fontSize={22}
                spacing={0.22}
                margin="0 0 24px 0"
              >
                {v}
              </Text>
              {i !== a.length - 1 && <div className="bp-divider" />}
            </React.Fragment>
          ))}
          <Button
            large
            outline
            color={c.salmon}
            margin="36px 0 0 0"
            path="/book"
          >
            Book Glam
          </Button>
        </div>
      </div>
    </BeautyProsWrapper>
  )
}

export default OurBeautyPros
